/**
 * AdempimentoCTA — F-004 Phase 4 (IMPL-P4-003).
 *
 * Bottone "Registra adempimento" che porta al flusso adempimento (proroga /
 * risoluzione / cessione) riusando la route `/app/pratiche/nuova` con i query
 * param `adempimentoMode=1&parentId=<praticaId>` — nessuna nuova `<Route>` in
 * `App.tsx` (Key Decision: riuso del precedente `correctMode` di F-005).
 *
 * Clone strutturale di `CorrectionCTA.tsx`: `Button asChild` + `Link` per il
 * rendering button-style con la semantica dell'ancora (navigazione SPA +
 * accessibilità nativa).
 *
 * Gating: NON è questo componente a decidere quando è visibile. La visibilità è
 * responsabilità del chiamante (`PraticaDetailPage` la mostra solo se
 * `stato === 'COMPLETATA'`; l'archivio la mostra incondizionatamente perché le
 * sue voci sono `COMPLETATA` per costruzione).
 */
import { Link } from 'react-router-dom';
import { FilePlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface AdempimentoCTAProps {
  praticaId: string;
  className?: string;
}

export function AdempimentoCTA({ praticaId, className }: AdempimentoCTAProps) {
  return (
    <Button asChild variant="default" size="sm" className={cn(className)}>
      <Link to={`/app/pratiche/nuova?adempimentoMode=1&parentId=${praticaId}`}>
        <FilePlus className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
        Registra adempimento
      </Link>
    </Button>
  );
}
